import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DoneAll from '@mui/icons-material/DoneAll';
import { CollapseCard } from '@totalsoft/rocket-ui';
import ApprovalLevelListComponent from './ApprovalLevelListComponent';
import ApprovalLevelsSummary from './ApprovalLevelsSummary';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import WrappedFakeText from 'components/common/WrappedFakeText';

const ApprovalLevelsCard = ({
  t,
  approvalLevels,
  loading,
  decisionTypes,
  applying,
  changeItemProperty,
  saveItem,
  applyItem,
  showApprovalHistory,
  setQueueSaveForIndex,
  currentUserId,
  selectedOffer,
  decisionReasons
}) => {
  return (
    <CollapseCard
      icon={DoneAll}
      title={t('Document.Decision.ApprovalLevels.Title')}
      subheader={<ApprovalLevelsSummary approvalLevels={approvalLevels.map(x => x.document)} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      {loading || !approvalLevels ? (
        <WrappedFakeText lines={6} />
      ) : (
        <CardNoResultsWrapper content={approvalLevels}>
          <ApprovalLevelListComponent
            decisionTypes={decisionTypes}
            decisionReasons={decisionReasons}
            applying={applying}
            onPropertyChange={changeItemProperty}
            onSaveItem={saveItem}
            onApplyItem={applyItem}
            approvalLevels={approvalLevels}
            showApprovalHistory={showApprovalHistory}
            setQueueSaveForIndex={setQueueSaveForIndex}
            currentUserId={currentUserId}
            selectedOffer={selectedOffer}
          />
        </CardNoResultsWrapper>
      )}
    </CollapseCard>
  );
};

ApprovalLevelsCard.propTypes = {
  t: PropTypes.func.isRequired,
  approvalLevels: PropTypes.array.isRequired,
  decisionTypes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  applying: PropTypes.bool.isRequired,
  changeItemProperty: PropTypes.func.isRequired,
  saveItem: PropTypes.func.isRequired,
  applyItem: PropTypes.func.isRequired,
  currentUserId: PropTypes.number,
  showApprovalHistory: PropTypes.func.isRequired,
  setQueueSaveForIndex: PropTypes.func.isRequired,
  selectedOffer: PropTypes.object,
  decisionReasons: PropTypes.array
};

export default withTranslation()(ApprovalLevelsCard);
